export const SHARE_MENU_CONTENT_CLASS =
  "rounded-lg bg-background-canvas p-2 shadow-md shadow-shadow-black-5 ring-1 ring-shadow-black-5"

export const SHARE_MENU_ITEM_CLASS =
  "items-start rounded-lg bg-background-canvas p-3 pr-10 focus:bg-background-surface data-[state=checked]:bg-background-surface [&>span:first-child]:top-1/2 [&>span:first-child]:right-3 [&>span:first-child]:-translate-y-1/2 [&>span:first-child_svg]:text-foreground-muted!"

export const SHARE_MENU_ITEM_DESCRIPTION_CLASS = "text-sm text-foreground-muted!"
